<template>
  <Page>
    <PageContent>
      <RouterView />
    </PageContent>
  </Page>
</template>

<script lang="ts" setup>
import Page from '@/components/page/Page.vue'
import PageContent from '@/components/page/PageContent.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.personal.title',
  },
})
</script>
